import TeamspaceImg from '@/shared/assets/images/teamspace.png';
import { MixpanelEvents } from '@/shared/thirdParty/mixpanel';

import { LimitedFeatureContent, ModalContent } from '../types';
import { getBullets } from './bullets';
import { BULLETS_HEADER_TEXT, BUTTON_TEXTS } from './texts';

const BASE_CONTENT: ModalContent = {
  title: 'Unlock Team spaces',
  bulletsHeader: BULLETS_HEADER_TEXT.withCreatorPro,
  buttonText: BUTTON_TEXTS.toCreatorPro,
  features: getBullets([
    'teamspaceCreatorPro',
    'translate100',
    'lipSync',
    'voiceCloneSettings',
    'voicePresets',
    'srtUploadDownload',
    'subtitles',
    'aiRewrite',
    'simultaneousMultiLanguageTranslation',
  ]),
  media: {
    src: TeamspaceImg,
    type: 'image',
  },
  // TODO: change mixpanel events
  mixpanelButtonClickEvent: MixpanelEvents.upgradeCustomVoiceModalClickPricing,
  mixpanelOpeningEvent: MixpanelEvents.upgradeCustomVoiceModalShown,
  subtitle: 'Upgrade to Creator Pro to have Team space with up to 5 members',
};

const CREATOR_PRO_PLAN_CONTENT = {
  ...BASE_CONTENT,
  bulletsHeader: BULLETS_HEADER_TEXT.inCreatorPro,
  buttonText: BUTTON_TEXTS.toBusiness,
  features: getBullets([
    'teamspaceBusiness',
    'translate500',
    'voicePresets10',
    'glossary',
    'simultaneousMultiLanguageTranslation',
    'api',
  ]),
  subtitle: 'Upgrade to Business to have Team space with up to 10 members',
};

const BUSINESS_PLAN_CONTENT = {
  ...BASE_CONTENT,
  bulletsHeader: BULLETS_HEADER_TEXT.inBusiness,
  buttonText: BUTTON_TEXTS.contactUs,
  features: getBullets([
    'teamspace',
    'translate2000',
    'voicePresetsUnlimited',
    'customPriceForMins',
    'humanInTheLoop',
    'businessContract',
    'personalManager',
  ]),
  // TODO: change mixpanel events
  mixpanelButtonClickEvent: MixpanelEvents.upgradeCustomVoiceModalClickContactUs,
  subtitle: 'Upgrade to Enterprise to have unlimited Team spaces and members',
};

export const TEAMSPACE_CONTENT: LimitedFeatureContent = {
  business: BUSINESS_PLAN_CONTENT,
  creator: BASE_CONTENT,
  creatorPro: CREATOR_PRO_PLAN_CONTENT,
  enterprise: BUSINESS_PLAN_CONTENT,
  starter: BASE_CONTENT,
  trial: BASE_CONTENT,
};
